export const SET_EVENTS = '@@events/set';
export const ADD_EVENT = '@@events/add';
export const ADD_EVENTS = '@@events/addEvents';
export const EDIT_EVENT = '@@events/edit';
export const DELETE_EVENT = '@@events/delete';

export const GENERATE_EVENTS_REQUEST = '@@session/generateEventsRequest';
export const GENERATE_EVENTS_FAILURE = '@@session/generateEventsFailure';
export const GENERATE_EVENTS_SUCCESS = '@@session/generateEventsSuccess';
